import { render, staticRenderFns } from "./cCookiePreferences.vue?vue&type=template&id=0abb521e&scoped=true"
import script from "./cCookiePreferences.vue?vue&type=script&lang=js"
export * from "./cCookiePreferences.vue?vue&type=script&lang=js"
import style0 from "./cCookiePreferences.vue?vue&type=style&index=0&id=0abb521e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb521e",
  null
  
)

export default component.exports